'use client';

import { Fragment, useState } from 'react';
import Script from 'next/script';

import { Theme } from './API/Theme';

import { Tinybar } from './Tinybar';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { Cookie } from './Cookie';
import Viewport from './Viewport';

import Sidebar from './Sidebar';

interface ICoreUI {
    className?: string;
    theme?: Theme;
    footer?: any;
    gradient?: boolean;
    children: React.ReactNode
}

const CoreUI = ({ className = '', theme = 'light', footer = {}, gradient, children }: ICoreUI) => {
    const [isCollapsed, setCollapsed] = useState<boolean>(true);
    const [distanceY, setDistanceY] = useState<number>(0);

    return (
        <Fragment>
            <Sidebar open={! isCollapsed} onClose={() => setCollapsed(true)} />
            <Viewport className={className} collapsed={isCollapsed} onScroll={y => setDistanceY(y)}>
                <Tinybar open={! isCollapsed} onOpen={() => setCollapsed(prevValue => ! prevValue)} theme={theme} distance={distanceY} />
                <Navbar theme={theme} gradient={gradient} distance={distanceY} />
                {children}
                <Footer {...footer} />
                <Cookie />
            </Viewport>
            <Script
                id='google-tag-manager'
                strategy='lazyOnload'
                src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_ANALYTICS_ID}`}
            />
            <Script
                id='google-analytics'
                strategy='lazyOnload'
            >
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${process.env.NEXT_PUBLIC_ANALYTICS_ID}', {
                        page_path: window.location.pathname
                    });
                `}
            </Script>
            <Script
                id='chatwoot'
                strategy='lazyOnload'
                src='https://app.chatwoot.com/packs/js/sdk.js'
                onLoad={() => {
                    window.chatwootSDK = window.chatwootSDK || {};

                    window.chatwootSDK.run({
                        baseUrl: 'https://app.chatwoot.com',
                        websiteToken: process.env.NEXT_PUBLIC_CHATWOOT_TOKEN
                    });
                }}
            />
            <Script
                id='trustpilot'
                strategy='lazyOnload'
                src='https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
                onLoad={() => {
                    window.Trustpilot = window.Trustpilot || {};
                    window.Trustpilot.loadFromElement(document.getElementById('trustbox'));
                }}
            />
        </Fragment>
    );
};

export { CoreUI };
export type { ICoreUI };